import { KeyframeNode } from "./KeyframeNode";
import { AnimationEvent } from "./AnimationEvent";
import { HalfFloatUtils } from "../../utils/HalfFloatUtils";
import { KeyFrameValueType } from "../component/Animator/KeyframeNodeOwner";
import { FloatKeyframe } from "../../maths/FloatKeyframe";
import { WeightedMode } from "../../maths/Keyframe";
import { QuaternionKeyframe } from "../../maths/QuaternionKeyframe";
import { Vector2Keyframe } from "../../maths/Vector2Keyframe";
import { Vector3Keyframe } from "../../maths/Vector3Keyframe";
import { Vector4Keyframe } from "../../maths/Vector4Keyframe";
import { BooleanKeyframe } from "../../maths/BooleanKeyframe";
export class AnimationClipParser04 {
    static READ_DATA() {
        AnimationClipParser04._DATA.offset = AnimationClipParser04._reader.readUint32();
        AnimationClipParser04._DATA.size = AnimationClipParser04._reader.readUint32();
    }
    static READ_BLOCK() {
        var count = AnimationClipParser04._BLOCK.count = AnimationClipParser04._reader.readUint16();
        var blockStarts = AnimationClipParser04._BLOCK.blockStarts = [];
        var blockLengths = AnimationClipParser04._BLOCK.blockLengths = [];
        for (var i = 0; i < count; i++) {
            blockStarts.push(AnimationClipParser04._reader.readUint32());
            blockLengths.push(AnimationClipParser04._reader.readUint32());
        }
    }
    static READ_STRINGS() {
        var offset = AnimationClipParser04._reader.readUint32();
        var count = AnimationClipParser04._reader.readUint16();
        var prePos = AnimationClipParser04._reader.pos;
        AnimationClipParser04._reader.pos = offset + AnimationClipParser04._DATA.offset;
        for (var i = 0; i < count; i++)
            AnimationClipParser04._strings[i] = AnimationClipParser04._reader.readUTFString();
        AnimationClipParser04._reader.pos = prePos;
    }
    static parse(clip, reader, version) {
        AnimationClipParser04._animationClip = clip;
        AnimationClipParser04._reader = reader;
        AnimationClipParser04._version = version;
        AnimationClipParser04.READ_DATA();
        AnimationClipParser04.READ_BLOCK();
        AnimationClipParser04.READ_STRINGS();
        for (var i = 0, n = AnimationClipParser04._BLOCK.count; i < n; i++) {
            var index = reader.readUint16();
            var blockName = AnimationClipParser04._strings[index];
            var fn = AnimationClipParser04["READ_" + blockName];
            if (fn == null)
                throw new Error("model file err,no this function:" + index + " " + blockName);
            else
                fn.call(null);
        }
        AnimationClipParser04._version = null;
        AnimationClipParser04._reader = null;
        AnimationClipParser04._animationClip = null;
    }
    static READ_ANIMATIONS() {
        var i, j;
        var node;
        var reader = AnimationClipParser04._reader;
        var startTimeTypes = [];
        var startTimeTypeCount = reader.readUint16();
        startTimeTypes.length = startTimeTypeCount;
        for (i = 0; i < startTimeTypeCount; i++)
            startTimeTypes[i] = reader.readFloat32();
        var clip = AnimationClipParser04._animationClip;
        clip.name = AnimationClipParser04._strings[reader.readUint16()];
        var clipDur = clip._duration = reader.readFloat32();
        clip.islooping = !!reader.readByte();
        clip._frameRate = reader.readInt16();
        var nodeCount = reader.readInt16();
        var nodes = clip._nodes;
        nodes.count = nodeCount;
        var nodesMap = clip._nodesMap = {};
        var nodesDic = clip._nodesDic = {};
        for (i = 0; i < nodeCount; i++) {
            node = new KeyframeNode();
            if ("LAYAANIMATION:WEIGHT_05" == AnimationClipParser04._version) {
                if (1 == reader.readByte()) {
                    node.propertyChangePath = AnimationClipParser04._strings[reader.readUint16()];
                }
                if (1 == reader.readByte()) {
                    node.callbackFunData = AnimationClipParser04._strings[reader.readUint16()];
                }
                let paramLen = reader.readUint8();
                let callParms = null;
                for (j = 0; j < paramLen; j++) {
                    if (null == callParms) {
                        callParms = [];
                    }
                    callParms.push(AnimationClipParser04._strings[reader.readUint16()]);
                }
                node.callParams = callParms;
            }
            nodes.setNodeByIndex(i, node);
            node._indexInList = i;
            var type = node.type = reader.readUint8();
            var pathLength = reader.readUint16();
            node._setOwnerPathCount(pathLength);
            for (j = 0; j < pathLength; j++)
                node._setOwnerPathByIndex(j, AnimationClipParser04._strings[reader.readUint16()]);
            var nodePath = node._joinOwnerPath("/");
            var mapArray = nodesMap[nodePath];
            (mapArray) || (nodesMap[nodePath] = mapArray = []);
            mapArray.push(node);
            node.propertyOwner = AnimationClipParser04._strings[reader.readUint16()];
            var propertyLength = reader.readUint16();
            node._setPropertyCount(propertyLength);
            for (j = 0; j < propertyLength; j++)
                node._setPropertyByIndex(j, AnimationClipParser04._strings[reader.readUint16()]);
            var fullPath = nodePath + "." + node.propertyOwner + "." + node._joinProperty(".");
            nodesDic[fullPath] = node;
            node.fullPath = fullPath;
            node.nodePath = nodePath;
            var keyframeCount = reader.readUint16();
            node._setKeyframeCount(keyframeCount);
            switch (AnimationClipParser04._version) {
                case "LAYAANIMATION:04":
                    for (j = 0; j < keyframeCount; j++) {
                        switch (type) {
                            case KeyFrameValueType.Float:
                                var floatKeyframe = new FloatKeyframe();
                                node._setKeyframeByIndex(j, floatKeyframe);
                                floatKeyframe.time = startTimeTypes[reader.readUint16()];
                                floatKeyframe.inTangent = reader.readFloat32();
                                floatKeyframe.outTangent = reader.readFloat32();
                                floatKeyframe.value = reader.readFloat32();
                                break;
                            case KeyFrameValueType.Position:
                            case KeyFrameValueType.Scale:
                            case KeyFrameValueType.RotationEuler:
                            case KeyFrameValueType.Vector3:
                                var floatArrayKeyframe = new Vector3Keyframe();
                                node._setKeyframeByIndex(j, floatArrayKeyframe);
                                floatArrayKeyframe.time = startTimeTypes[reader.readUint16()];
                                var inTangent = floatArrayKeyframe.inTangent;
                                var outTangent = floatArrayKeyframe.outTangent;
                                var value = floatArrayKeyframe.value;
                                inTangent.x = reader.readFloat32();
                                inTangent.y = reader.readFloat32();
                                inTangent.z = reader.readFloat32();
                                outTangent.x = reader.readFloat32();
                                outTangent.y = reader.readFloat32();
                                outTangent.z = reader.readFloat32();
                                value.x = reader.readFloat32();
                                value.y = reader.readFloat32();
                                value.z = reader.readFloat32();
                                break;
                            case KeyFrameValueType.Rotation:
                                var quaternionKeyframe = new QuaternionKeyframe();
                                node._setKeyframeByIndex(j, quaternionKeyframe);
                                quaternionKeyframe.time = startTimeTypes[reader.readUint16()];
                                var inTangentQua = quaternionKeyframe.inTangent;
                                var outTangentQua = quaternionKeyframe.outTangent;
                                var valueQua = quaternionKeyframe.value;
                                inTangentQua.x = reader.readFloat32();
                                inTangentQua.y = reader.readFloat32();
                                inTangentQua.z = reader.readFloat32();
                                inTangentQua.w = reader.readFloat32();
                                outTangentQua.x = reader.readFloat32();
                                outTangentQua.y = reader.readFloat32();
                                outTangentQua.z = reader.readFloat32();
                                outTangentQua.w = reader.readFloat32();
                                valueQua.x = reader.readFloat32();
                                valueQua.y = reader.readFloat32();
                                valueQua.z = reader.readFloat32();
                                valueQua.w = reader.readFloat32();
                                break;
                            case KeyFrameValueType.Vector2:
                                var vec2Keyfram = new Vector2Keyframe();
                                node._setKeyframeByIndex(j, vec2Keyfram);
                                vec2Keyfram.time = startTimeTypes[reader.readUint16()];
                                var inTangentV2 = vec2Keyfram.inTangent;
                                var outTangentV2 = vec2Keyfram.outTangent;
                                var valueV2 = vec2Keyfram.value;
                                inTangentV2.x = reader.readFloat32();
                                inTangentV2.y = reader.readFloat32();
                                outTangentV2.x = reader.readFloat32();
                                outTangentV2.y = reader.readFloat32();
                                valueV2.x = reader.readFloat32();
                                valueV2.y = reader.readFloat32();
                                break;
                            case KeyFrameValueType.Vector4:
                            case KeyFrameValueType.Color:
                                var vec4Keyfram = new Vector4Keyframe();
                                node._setKeyframeByIndex(j, vec4Keyfram);
                                vec4Keyfram.time = startTimeTypes[reader.readUint16()];
                                var inTangentV4 = vec4Keyfram.inTangent;
                                var outTangentV4 = vec4Keyfram.outTangent;
                                var valueV4 = vec4Keyfram.value;
                                inTangentV4.x = reader.readFloat32();
                                inTangentV4.y = reader.readFloat32();
                                inTangentV4.z = reader.readFloat32();
                                inTangentV4.w = reader.readFloat32();
                                outTangentV4.x = reader.readFloat32();
                                outTangentV4.y = reader.readFloat32();
                                outTangentV4.z = reader.readFloat32();
                                outTangentV4.w = reader.readFloat32();
                                valueV4.x = reader.readFloat32();
                                valueV4.y = reader.readFloat32();
                                valueV4.z = reader.readFloat32();
                                valueV4.w = reader.readFloat32();
                                break;
                            default:
                                throw new Error("AnimationClipParser04:unknown type.");
                        }
                    }
                    break;
                case "LAYAANIMATION:WEIGHT_04":
                case "LAYAANIMATION:WEIGHT_05":
                    for (j = 0; j < keyframeCount; j++) {
                        let isWeight = 1;
                        switch (type) {
                            case KeyFrameValueType.Boolean:
                                let booleanKeyframe = new BooleanKeyframe();
                                node._setKeyframeByIndex(j, booleanKeyframe);
                                booleanKeyframe.time = startTimeTypes[reader.readUint16()];
                                booleanKeyframe.value = reader.readByte() == 1;
                                break;
                            case KeyFrameValueType.Float:
                                var floatKeyframe = new FloatKeyframe();
                                node._setKeyframeByIndex(j, floatKeyframe);
                                floatKeyframe.time = startTimeTypes[reader.readUint16()];
                                floatKeyframe.inTangent = reader.readFloat32();
                                floatKeyframe.outTangent = reader.readFloat32();
                                floatKeyframe.value = reader.readFloat32();
                                floatKeyframe.weightedMode = reader.readUint8();
                                if ("LAYAANIMATION:WEIGHT_05" == AnimationClipParser04._version) {
                                    if (WeightedMode.In == floatKeyframe.weightedMode || WeightedMode.Both == floatKeyframe.weightedMode) {
                                        floatKeyframe.inWeight = reader.readFloat32();
                                    }
                                    if (WeightedMode.Out == floatKeyframe.weightedMode || WeightedMode.Both == floatKeyframe.weightedMode) {
                                        floatKeyframe.outWeight = reader.readFloat32();
                                    }
                                }
                                else {
                                    floatKeyframe.inWeight = reader.readFloat32();
                                    floatKeyframe.outWeight = reader.readFloat32();
                                }
                                break;
                            case KeyFrameValueType.Position:
                            case KeyFrameValueType.Scale:
                            case KeyFrameValueType.RotationEuler:
                            case KeyFrameValueType.Vector3:
                                var floatArrayKeyframe = new Vector3Keyframe(true);
                                node._setKeyframeByIndex(j, floatArrayKeyframe);
                                floatArrayKeyframe.time = startTimeTypes[reader.readUint16()];
                                var inTangent = floatArrayKeyframe.inTangent;
                                var outTangent = floatArrayKeyframe.outTangent;
                                var value = floatArrayKeyframe.value;
                                let weidhtMode = floatArrayKeyframe.weightedMode;
                                let inWeight = floatArrayKeyframe.inWeight;
                                let outWeight = floatArrayKeyframe.outWeight;
                                inTangent.x = reader.readFloat32();
                                inTangent.y = reader.readFloat32();
                                inTangent.z = reader.readFloat32();
                                outTangent.x = reader.readFloat32();
                                outTangent.y = reader.readFloat32();
                                outTangent.z = reader.readFloat32();
                                value.x = reader.readFloat32();
                                value.y = reader.readFloat32();
                                value.z = reader.readFloat32();
                                if ("LAYAANIMATION:WEIGHT_05" == AnimationClipParser04._version) {
                                    isWeight = reader.readByte();
                                }
                                if (1 == isWeight) {
                                    weidhtMode.x = reader.readUint8();
                                    weidhtMode.y = reader.readUint8();
                                    weidhtMode.z = reader.readUint8();
                                    inWeight.x = reader.readFloat32();
                                    inWeight.y = reader.readFloat32();
                                    inWeight.z = reader.readFloat32();
                                    outWeight.x = reader.readFloat32();
                                    outWeight.y = reader.readFloat32();
                                    outWeight.z = reader.readFloat32();
                                }
                                break;
                            case KeyFrameValueType.Rotation:
                                var quaternionKeyframe = new QuaternionKeyframe(true);
                                node._setKeyframeByIndex(j, quaternionKeyframe);
                                quaternionKeyframe.time = startTimeTypes[reader.readUint16()];
                                var inTangentQua = quaternionKeyframe.inTangent;
                                var outTangentQua = quaternionKeyframe.outTangent;
                                var valueQua = quaternionKeyframe.value;
                                let weightModeV4 = quaternionKeyframe.weightedMode;
                                let inWeightQua = quaternionKeyframe.inWeight;
                                let outWeightQua = quaternionKeyframe.outWeight;
                                inTangentQua.x = reader.readFloat32();
                                inTangentQua.y = reader.readFloat32();
                                inTangentQua.z = reader.readFloat32();
                                inTangentQua.w = reader.readFloat32();
                                outTangentQua.x = reader.readFloat32();
                                outTangentQua.y = reader.readFloat32();
                                outTangentQua.z = reader.readFloat32();
                                outTangentQua.w = reader.readFloat32();
                                valueQua.x = reader.readFloat32();
                                valueQua.y = reader.readFloat32();
                                valueQua.z = reader.readFloat32();
                                valueQua.w = reader.readFloat32();
                                if ("LAYAANIMATION:WEIGHT_05" == AnimationClipParser04._version) {
                                    isWeight = reader.readByte();
                                }
                                if (1 == isWeight) {
                                    weightModeV4.x = reader.readUint8();
                                    weightModeV4.y = reader.readUint8();
                                    weightModeV4.z = reader.readUint8();
                                    weightModeV4.w = reader.readUint8();
                                    inWeightQua.x = reader.readFloat32();
                                    inWeightQua.y = reader.readFloat32();
                                    inWeightQua.z = reader.readFloat32();
                                    inWeightQua.w = reader.readFloat32();
                                    outWeightQua.x = reader.readFloat32();
                                    outWeightQua.y = reader.readFloat32();
                                    outWeightQua.z = reader.readFloat32();
                                    outWeightQua.w = reader.readFloat32();
                                }
                                break;
                            case KeyFrameValueType.Vector2:
                                var vec2Keyfram = new Vector2Keyframe(true);
                                node._setKeyframeByIndex(j, vec2Keyfram);
                                vec2Keyfram.time = startTimeTypes[reader.readUint16()];
                                var inTangentV2 = vec2Keyfram.inTangent;
                                var outTangentV2 = vec2Keyfram.outTangent;
                                var valueV2 = vec2Keyfram.value;
                                let weightModeV2 = vec2Keyfram.weightedMode;
                                let inWeightV2 = vec2Keyfram.inWeight;
                                let outWeightV2 = vec2Keyfram.outWeight;
                                inTangentV2.x = reader.readFloat32();
                                inTangentV2.y = reader.readFloat32();
                                outTangentV2.x = reader.readFloat32();
                                outTangentV2.y = reader.readFloat32();
                                valueV2.x = reader.readFloat32();
                                valueV2.y = reader.readFloat32();
                                if ("LAYAANIMATION:WEIGHT_05" == AnimationClipParser04._version) {
                                    isWeight = reader.readByte();
                                }
                                if (1 == isWeight) {
                                    weightModeV2.x = reader.readUint8();
                                    weightModeV2.y = reader.readUint8();
                                    inWeightV2.x = reader.readFloat32();
                                    inWeightV2.y = reader.readFloat32();
                                    outWeightV2.x = reader.readFloat32();
                                    outWeightV2.y = reader.readFloat32();
                                }
                                break;
                            case KeyFrameValueType.Vector4:
                            case KeyFrameValueType.Color:
                                var vec4Keyfram = new Vector4Keyframe(true);
                                node._setKeyframeByIndex(j, vec4Keyfram);
                                vec4Keyfram.time = startTimeTypes[reader.readUint16()];
                                var inTangentV4 = vec4Keyfram.inTangent;
                                var outTangentV4 = vec4Keyfram.outTangent;
                                var valueV4 = vec4Keyfram.value;
                                var weightMode_V4 = vec4Keyfram.weightedMode;
                                var inWeightV4 = vec4Keyfram.inWeight;
                                var outWeightV4 = vec4Keyfram.outWeight;
                                inTangentV4.x = reader.readFloat32();
                                inTangentV4.y = reader.readFloat32();
                                inTangentV4.z = reader.readFloat32();
                                inTangentV4.w = reader.readFloat32();
                                outTangentV4.x = reader.readFloat32();
                                outTangentV4.y = reader.readFloat32();
                                outTangentV4.z = reader.readFloat32();
                                outTangentV4.w = reader.readFloat32();
                                valueV4.x = reader.readFloat32();
                                valueV4.y = reader.readFloat32();
                                valueV4.z = reader.readFloat32();
                                valueV4.w = reader.readFloat32();
                                if ("LAYAANIMATION:WEIGHT_05" == AnimationClipParser04._version) {
                                    isWeight = reader.readByte();
                                }
                                if (1 == isWeight) {
                                    weightMode_V4.x = reader.readUint8();
                                    weightMode_V4.y = reader.readUint8();
                                    weightMode_V4.z = reader.readUint8();
                                    weightMode_V4.w = reader.readUint8();
                                    inWeightV4.x = reader.readFloat32();
                                    inWeightV4.y = reader.readFloat32();
                                    inWeightV4.z = reader.readFloat32();
                                    inWeightV4.w = reader.readFloat32();
                                    outWeightV4.x = reader.readFloat32();
                                    outWeightV4.y = reader.readFloat32();
                                    outWeightV4.z = reader.readFloat32();
                                    outWeightV4.w = reader.readFloat32();
                                }
                                break;
                            default:
                                throw "AnimationClipParser04:unknown type.";
                        }
                    }
                    break;
                case "LAYAANIMATION:COMPRESSION_04":
                    for (j = 0; j < keyframeCount; j++) {
                        switch (type) {
                            case KeyFrameValueType.Float:
                                floatKeyframe = new FloatKeyframe();
                                node._setKeyframeByIndex(j, floatKeyframe);
                                floatKeyframe.time = startTimeTypes[reader.readUint16()];
                                floatKeyframe.inTangent = HalfFloatUtils.convertToNumber(reader.readUint16());
                                floatKeyframe.outTangent = HalfFloatUtils.convertToNumber(reader.readUint16());
                                floatKeyframe.value = HalfFloatUtils.convertToNumber(reader.readUint16());
                                break;
                            case KeyFrameValueType.Position:
                            case KeyFrameValueType.Scale:
                            case KeyFrameValueType.RotationEuler:
                            case KeyFrameValueType.Vector3:
                                floatArrayKeyframe = new Vector3Keyframe();
                                node._setKeyframeByIndex(j, floatArrayKeyframe);
                                floatArrayKeyframe.time = startTimeTypes[reader.readUint16()];
                                inTangent = floatArrayKeyframe.inTangent;
                                outTangent = floatArrayKeyframe.outTangent;
                                value = floatArrayKeyframe.value;
                                inTangent.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                inTangent.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                inTangent.z = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangent.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangent.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangent.z = HalfFloatUtils.convertToNumber(reader.readUint16());
                                value.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                value.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                value.z = HalfFloatUtils.convertToNumber(reader.readUint16());
                                break;
                            case KeyFrameValueType.Rotation:
                                quaternionKeyframe = new QuaternionKeyframe();
                                node._setKeyframeByIndex(j, quaternionKeyframe);
                                quaternionKeyframe.time = startTimeTypes[reader.readUint16()];
                                inTangentQua = quaternionKeyframe.inTangent;
                                outTangentQua = quaternionKeyframe.outTangent;
                                valueQua = quaternionKeyframe.value;
                                inTangentQua.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                inTangentQua.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                inTangentQua.z = HalfFloatUtils.convertToNumber(reader.readUint16());
                                inTangentQua.w = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangentQua.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangentQua.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangentQua.z = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangentQua.w = HalfFloatUtils.convertToNumber(reader.readUint16());
                                valueQua.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                valueQua.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                valueQua.z = HalfFloatUtils.convertToNumber(reader.readUint16());
                                valueQua.w = HalfFloatUtils.convertToNumber(reader.readUint16());
                                break;
                            case KeyFrameValueType.Vector2:
                                var vec2Keyfram = new Vector2Keyframe();
                                node._setKeyframeByIndex(j, vec2Keyfram);
                                vec2Keyfram.time = startTimeTypes[reader.readUint16()];
                                var inTangentV2 = vec2Keyfram.inTangent;
                                var outTangentV2 = vec2Keyfram.outTangent;
                                var valueV2 = vec2Keyfram.value;
                                inTangentV2.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                inTangentV2.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangentV2.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangentV2.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                valueV2.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                valueV2.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                break;
                            case KeyFrameValueType.Vector4:
                            case KeyFrameValueType.Color:
                                var vec4Keyfram = new Vector4Keyframe();
                                node._setKeyframeByIndex(j, vec4Keyfram);
                                vec4Keyfram.time = startTimeTypes[reader.readUint16()];
                                var inTangentV4 = vec4Keyfram.inTangent;
                                var outTangentV4 = vec4Keyfram.outTangent;
                                var valueV4 = vec4Keyfram.value;
                                inTangentV4.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                inTangentV4.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                inTangentV4.z = HalfFloatUtils.convertToNumber(reader.readUint16());
                                inTangentV4.w = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangentV4.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangentV4.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangentV4.z = HalfFloatUtils.convertToNumber(reader.readUint16());
                                outTangentV4.w = HalfFloatUtils.convertToNumber(reader.readUint16());
                                valueV4.x = HalfFloatUtils.convertToNumber(reader.readUint16());
                                valueV4.y = HalfFloatUtils.convertToNumber(reader.readUint16());
                                valueV4.z = HalfFloatUtils.convertToNumber(reader.readUint16());
                                valueV4.w = HalfFloatUtils.convertToNumber(reader.readUint16());
                                break;
                            default:
                                throw "AnimationClipParser04:unknown type.";
                        }
                    }
                    break;
            }
        }
        var eventCount = reader.readUint16();
        for (i = 0; i < eventCount; i++) {
            var event = new AnimationEvent();
            event.time = Math.min(clipDur, reader.readFloat32());
            event.eventName = AnimationClipParser04._strings[reader.readUint16()];
            var params = [];
            var paramCount = reader.readUint16();
            (paramCount > 0) && (event.params = params = []);
            for (j = 0; j < paramCount; j++) {
                var eventType = reader.readByte();
                switch (eventType) {
                    case 0:
                        params.push(!!reader.readByte());
                        break;
                    case 1:
                        params.push(reader.readInt32());
                        break;
                    case 2:
                        params.push(reader.readFloat32());
                        break;
                    case 3:
                        params.push(AnimationClipParser04._strings[reader.readUint16()]);
                        break;
                    default:
                        throw new Error("unknown type.");
                }
            }
            clip.addEvent(event);
        }
    }
}
AnimationClipParser04._strings = [];
AnimationClipParser04._BLOCK = { count: 0 };
AnimationClipParser04._DATA = { offset: 0, size: 0 };
